import React, { useEffect,useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { AppContainer, MainContentContainer, BodyContainer } from '../../resources/styling/appStyle';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import { Grid, Chip, InputAdornment, OutlinedInput, InputLabel, FormControl, MenuItem, Box, Select, Modal, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { AppButton } from '../../resources/styling';
import { colors } from '../../resources/theme/colors';
import { TablePagination, CircularProgress, Typography } from '@mui/material';
import { sa, DataTable, PillButton, SectionHeaderRow } from '../../components/superAdminUi';
import { ProdButton } from '../../resources/styling';

import schoolService from '../../services/api/schoolService';
import { toast } from 'react-toastify';
import ConfirmDialog from '../../components/common/ConfirmDialog';
import { useCanArchive } from '../../hooks/useCanArchive';
import { archiveSchoolAction } from '../mat/archive/archiveActions';
import { useArchiveConfirmation } from '../mat/archive/useArchiveConfirmation';
import { welbeeDashboardLogo } from '../../resources/images/index';
import { superAdminActions } from '../../store/superAdminStore';
import { storageService } from '../../services';
import { routesObj } from '../../routes';
import { bindActionCreators } from 'redux';
import { limitAverageValue } from '../../utils/roundScore';
import { schoolListFlags, WebStorageNames } from '../../utils/Constants';
import { DateFormat } from '../../utils/CommonFunctions';
import { getDate } from 'date-fns';
import { isNull } from 'lodash';
import { borderRadius } from '@mui/system';
import {
  impersonate,
  ScopeType,
  getCallbackUrlForProduct,
  getHomeCallbackUrl
} from '../../utils/impersonateUtils';
import { Product, PRODUCT_NAMES, PRODUCT_DISPLAY_NAMES, EI_TIER_PRODUCT_IDS } from '../../utils/Constants';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  p: 3,
};
const { mandy } = colors;

// Presentation for the Super Admin Schools listing, rebuilt on the shared Super Admin design
// system so it matches the redesigned screens: purple-header zebra DataTable, teal/coral/outline
// pill actions and a styled search box. Every data fetch, filter, sort, page, impersonation and
// archive handler is left exactly as it was — this is a presentation-only pass.

const PageStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sa.space.section};
  font-family: ${sa.font.family};
`;

const SearchForm = styled.form`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 280px;
  max-width: 100%;
  padding: 7px 12px;
  background: ${sa.color.white};
  border: 1px solid ${sa.color.stroke};
  border-radius: ${sa.radius.sm};

  input {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    font-family: ${sa.font.family};
    font-size: 13px;
    color: ${sa.color.text};
  }

  svg {
    color: ${sa.color.textGray};
    font-size: 18px;
  }
`;

// Sort control living inside the purple table header — white label plus a direction glyph.
const SortHeaderButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: ${sa.color.white};
  font-family: ${sa.font.family};
  font-weight: ${sa.font.bold};
  font-size: inherit;
`;

// Live / Test filter as the Figma pill tab bar (white bordered track, teal active pill) —
// matching the Groups listing so both listings read identically.
const TabBar = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;  
`;

const TabButton = styled.button`
  border: none;
  cursor: pointer;
  font-family: ${sa.font.family};
  font-weight: ${sa.font.semibold};
  font-size: 14px;
  line-height: normal;
  padding: 12px 18px;
  border-radius: ${sa.radius.sm};
  background: ${(p) => (p.$active ? sa.color.teal : sa.color.tabInactive)};
  color: ${(p) => (p.$active ? sa.color.white : sa.color.text)};
  transition: background-color 0.15s ease-in-out;
`;

const ProductCell = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

const ActionCell = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
`;

const NoProducts = styled.span`
  font-family: ${sa.font.family};
  font-size: 12px;
  color: ${sa.color.textGray};
`;

const SchoolNameText = styled.span`
  font-weight: ${sa.font.semibold};
  color: ${sa.color.text};
`;

const HomeButton = styled(PillButton)`
  background: #de9868;
`;

const CenterState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

const PaginationRow = styled.div`
  margin-top: 4px;

  .MuiTablePagination-toolbar {
    padding-left: 0;
  }
`;

// Let the Products and Action cells wrap their pills instead of being clipped by the table's
// default single-line cell rule.
const wrapCellStyle = { whiteSpace: 'normal', overflow: 'visible' };

function SchoolListing() {

    const navigate = useHistory();
    const canArchive = useCanArchive();
    const { requestConfirmation, dialogProps: archiveDialogProps } = useArchiveConfirmation();
    const [sort, setSort] = React.useState('');
    const [value, setValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
      setValue(newValue);
    };

    const handleChange = (event) => {
        setSort(event.target.value);
    };

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);



  const [adminDashboardInfo, setAdminDashboardInfo] = useState({});
  const [surveys, setSurveys] = React.useState([])
  const [mysurvey, setMysurvey] = React.useState([])
  const [filteredSurveys, setFilteredSurveys] = React.useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [addloading, setaddLoading] = useState(false);
  const [error, setError] = useState(null);
  const [order, setOrder] = useState('asc'); // 'asc' or 'desc'
  const [orderBy, setOrderBy] = useState('Id'); // Default column to sort by
  const [searchQuery, setSearchQuery] = useState(''); // Search query state
  const [productName, setProductName] = React.useState([]);
  const [FileVal, setFile] = React.useState('');
  const [FileNameVal, setFileName] = React.useState('');
  const [TrancateFileName, setTrancateFileName] = React.useState('');
  const [impersonateLoading, setImpersonateLoading] = React.useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);


  // Load schools - using old API with client-side filtering, sorting, and pagination
  const loadSchools = React.useCallback(() => {
    setLoading(true);

    schoolService
      .getSchoolList(false) // false = not just schools with live surveys
      .then((response) => {
        if (response.success && response.data) {
          let allData = Array.isArray(response.data) ? response.data : [];

          // Exclude specific test account IDs (190, 191, 243)
          const excludedTestIds = [190, 191, 243];
          allData = allData.filter(s => !excludedTestIds.includes(s.Id));

          // Filter out schools in MAT groups (they appear in Groups listing)
          allData = allData.filter((x) => !x.IsArchived && isNull(x.MatGroupId));

          // Filter by test account status based on tab
          // FIX: Explicitly check IsTestAccount to prevent test accounts from appearing in Live Schools after refresh
          const includeOnlyTestAccounts = value === 1; // Tab 0 = Live Schools, Tab 1 = Test Schools
          if (includeOnlyTestAccounts) {
            // Only show test accounts
            allData = allData.filter(s => Boolean(s.IsTestAccount) === true);
          } else {
            // Only show live schools - explicitly exclude test accounts
            allData = allData.filter(s => Boolean(s.IsTestAccount) === false);
          }

          // Apply search filter
          if (searchQuery && searchQuery.trim()) {
            const searchLower = searchQuery.trim().toLowerCase();
            allData = allData.filter(s =>
              (s.Name && s.Name.toLowerCase().includes(searchLower)) ||
              (s.Address && s.Address.toLowerCase().includes(searchLower))
            );
          }

          // Apply sorting
          const sortedData = [...allData].sort((a, b) => {
            let aVal, bVal;
            switch (orderBy) {
              case 'Name':
                aVal = (a.Name || '').toLowerCase();
                bVal = (b.Name || '').toLowerCase();
                break;
              case 'Id':
                aVal = a.Id || 0;
                bVal = b.Id || 0;
                break;
              case 'Address':
                aVal = (a.Address || '').toLowerCase();
                bVal = (b.Address || '').toLowerCase();
                break;
              default:
                aVal = a.Id || 0;
                bVal = b.Id || 0;
            }

            if (order === 'asc') {
              return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
            } else {
              return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
            }
          });

          // Apply pagination
          const startIndex = page * rowsPerPage;
          const endIndex = startIndex + rowsPerPage;
          const paginatedData = sortedData.slice(startIndex, endIndex);

          setAdminDashboardInfo({ data: paginatedData });
          setTotalCount(sortedData.length);
          setTotalPages(Math.ceil(sortedData.length / rowsPerPage));
          setLoading(false);
        } else {
          setLoading(false);
          setError('Failed to load schools');
        }
      })
      .catch((err) => {
        console.error('Error loading schools:', err);
        setLoading(false);
        setError('Error loading schools');
      });
  }, [page, rowsPerPage, orderBy, order, searchQuery, value]);

  useEffect(() => {
    loadSchools();
  }, [loadSchools]);

   const handleSchoolDetails = (id) => {
      // Handle edit action
      console.log('Edit item with ID:', id);
      navigate.push(`/school-detail?schoolId=${id}`)
      // You can open a modal or navigate to an edit page here
    };

  const handleProductChange = (event) => {
    const {
      target: { value },
    } = event;
    setProductName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  /* Welbee Grid Properties and function starts*/
  const handleDetails = (id) => {
    // Handle edit action
    console.log('Edit item with ID:', id);
    // You can open a modal or navigate to an edit page here
  };

  // Named distinctly from the product-chip remove handler below — they are NOT the same.
  const handleArchiveClick = (schoolId) => {
    requestConfirmation(archiveSchoolAction({ schoolId }), loadSchools);
  };

  // Product-filter chips pass a React event to onDelete, not a school id — keep this
  // separate so removing a chip never triggers the archive flow.
  const handleChipDelete = () => {};

  const handleWelbeeChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleWelbeeChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleWelbeeSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    setPage(0); // Reset to first page when sorting changes
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when searching
  };

  // Data is already filtered and sorted on the server
  const sortedWelbeeData = adminDashboardInfo.data || [];


//New School Additional functons
 const [items, setItems] = useState([]);
 const [formData, setFormData] = useState({
    establishmentName: '',
    numberofpupils: '',
    address3: '',
    urn: '',
  });
  // Handle input changes

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };


  const addItem = () => {

    if(formData.establishmentName =="")
    {
      toast.error('Please enter School Name');
    }
    else if(formData.urn=="")
    {
      toast.error('Please enter a School URN');
    }
    else
    {
      setaddLoading(true);
      // Create new item object
      //debugger;
      const newItem = {
          Id: Date.now(), // Using timestamp as a simple unique ID
          Name: formData.establishmentName,
          NumberOfPupil: formData.numberofpupils === ""?0:formData.numberofpupils, // Convert string to number
          Address: formData.address3,
          WondeeSchoolUrn:formData.urn,
          File:  FileVal,
          FileName : FileNameVal,
          SchoolProducts:[],
        };
        // Add to items array
        // setItems([...items, newItem]);
        if(newItem.establishmentName !== '' && newItem.urn !== '')
        {
          setItems([...items, newItem]);
          // Reset form
          const updateProds=productName.map(item=>
            item===PRODUCT_DISPLAY_NAMES[Product.MAIN_APP_TOOLKIT]?'Main App and Toolkit':item
          );
          //add the add school logic here
          newItem.SchoolProducts=updateProds;

          //schoolService.addNewIndividualSchool(newItem.EstablishmentName,newItem.Address3,newItem.URN,newItem.NumberOfPupils,updateProds).then((response) => {

          schoolService.addNewIndividualSchoolPost(newItem).then((response) => {
            const { success, message } = response;
            if (success)
            {
                toast.success('School added successfully');
                // Reset form
                setFormData({
                  establishmentName: '',
                  numberofpupils: '',
                  address3: '',
                  urn: ''
                });
                setProductName([]);
                setaddLoading(false);
            }
            else
            {
                toast.error(message);
            }
          });
        }
        else{
            if(newItem.establishmentName == '')
            {
              toast.error('Please enter School Name');
            }
            else if(newItem.urn == '')
          {
              toast.error('Please enter School URN');
          }
        }
        // alert('school save called');
        // debugger;

      }

  };

  const removeItem = (idToRemove) => {
    setItems(items.filter(item => item.id !== idToRemove));
  };

  const updateItem = (idToUpdate, updatedProperties) => {
    setItems(items.map(item =>
      item.id === idToUpdate ? { ...item, ...updatedProperties } : item
    ));
  };
 //New School Additional functons

  if (error) {
    return (
      <Typography variant="h6" color="error" align="center">
        {error}
      </Typography>
    );
  }



  // Identity stores no school or group records, so the audit trail can only name the customer a
  // super admin entered if we send the name with the impersonation. Both are already on screen
  // here; when one can't be resolved the API falls back to "<Type> <Id>".
    const auditEntityName = (schoolId) =>
      (data || []).find((s) => String(s?.Id) === String(schoolId))?.Name || '';

    const handleEDUIntellSchoolclick = async (MATId, SchoolId) => {
      const callbackUrl = getCallbackUrlForProduct(Product.EDU_INTELLIGENCE);
      const buttonKey = `edu-${SchoolId}`;

      await impersonate({
        entityType: ScopeType.SCHOOL,
        entityId: SchoolId,
        entityName: auditEntityName(SchoolId),
        groupId: null,
        callbackUrl,
        setLoading: (loading) => {
          setImpersonateLoading(prev => ({ ...prev, [buttonKey]: loading }));
        },
      productName: PRODUCT_DISPLAY_NAMES[Product.EDU_INTELLIGENCE],
      productType: Product.EDU_INTELLIGENCE,
      });
    };

    const handleSchoolInsightsclick = async (MATId, SchoolId, productId) => {
      const callbackUrl = getCallbackUrlForProduct(productId);
      const buttonKey = `insights-${productId}-${SchoolId}`;

      await impersonate({
        entityType: ScopeType.SCHOOL,
        entityId: SchoolId,
        entityName: auditEntityName(SchoolId),
        groupId: null,
        callbackUrl,
        setLoading: (loading) => {
          setImpersonateLoading(prev => ({ ...prev, [buttonKey]: loading }));
        },
      productName: PRODUCT_DISPLAY_NAMES[productId] || 'Insights',
      productType: productId,
      });
    };

    const handleSchoolWelbeingclick = async (MATId, SchoolId, email) => {
      const callbackUrl = getCallbackUrlForProduct(Product.MAIN_APP_TOOLKIT);
      const buttonKey = `wellbeing-${SchoolId}`;

      await impersonate({
        entityType: ScopeType.SCHOOL,
        entityId: SchoolId,
        entityName: auditEntityName(SchoolId),
        groupId: null,
        callbackUrl,
        setLoading: (loading) => {
          setImpersonateLoading(prev => ({ ...prev, [buttonKey]: loading }));
        },
      productName: PRODUCT_DISPLAY_NAMES[Product.MAIN_APP_TOOLKIT],
      productType: Product.MAIN_APP_TOOLKIT,
      email,
      });
    };

    const handleSchoolHomeclick = async (MATId, SchoolId) => {
      const callbackUrl = getHomeCallbackUrl(ScopeType.SCHOOL);
      const buttonKey = `home-${SchoolId}`;

      await impersonate({
        entityType: ScopeType.SCHOOL,
        entityId: SchoolId,
        entityName: auditEntityName(SchoolId),
        groupId: null,
        callbackUrl,
        setLoading: (loading) => {
          setImpersonateLoading(prev => ({ ...prev, [buttonKey]: loading }));
        },
        productName: 'Home'
      });
    };

  // Clickable sortable column header for the schools DataTable — preserves the exact
  // sort properties the old TableSortLabels used (Name / WondeeSchoolUrn / Email / Products).
  const sortHeader = (label, property) => {
    const active = orderBy === property;
    return (
      <SortHeaderButton type='button' onClick={() => handleWelbeeSort(property)}>
        {label}
        {active
          ? (order === 'asc'
              ? <ArrowUpwardIcon sx={{ fontSize: 15 }} />
              : <ArrowDownwardIcon sx={{ fontSize: 15 }} />)
          : <SwapVertIcon sx={{ fontSize: 15, opacity: 0.75 }} />}
      </SortHeaderButton>
    );
  };

  // The Products cell: each subscribed product renders as a pill that impersonates into that
  // product, exactly as before (same handlers, keys, disabled state and loading label).
  const renderProductButtons = (row) => {
    if (!(row.schoolProductsList && row.schoolProductsList.length > 0)) {
      return <NoProducts>No products available.</NoProducts>;
    }
    const uniqueProducts = row.schoolProductsList.filter((item, index, self) =>
      self.findIndex((i) => i.Product === item.Product) === index
    );
    return (
      <ProductCell>
        {uniqueProducts.map((schoolProds) => (
          <React.Fragment key={schoolProds.id}>
            {schoolProds.Product === Product.MAIN_APP_TOOLKIT && (
              <ProdButton                
                className='staff-chip'
                onClick={() => handleSchoolWelbeingclick(schoolProds.MatId, schoolProds.SchoolId, row?.Email)}
                disabled={impersonateLoading[`wellbeing-${schoolProds.SchoolId}`]}
              >
                {impersonateLoading[`wellbeing-${schoolProds.SchoolId}`] ? 'Loading...' : 'Main App & Toolkit'}
              </ProdButton>
            )}
            {schoolProds.Product === Product.STUDENT_INSIGHT && (
              <ProdButton                
                className='parent-chip'
                onClick={() => handleSchoolInsightsclick(schoolProds.MatId, schoolProds.SchoolId, 2)}
                disabled={impersonateLoading[`insights-${Product.STUDENT_INSIGHT}-${schoolProds.SchoolId}`]}
              >
                {impersonateLoading[`insights-${Product.STUDENT_INSIGHT}-${schoolProds.SchoolId}`] ? 'Loading...' : 'Student Insight'}
              </ProdButton>
            )}
            {schoolProds.Product === Product.PARENTS_INSIGHTS && (
              <ProdButton                
                className='insight-chip'
                onClick={() => handleSchoolInsightsclick(schoolProds.MatId, schoolProds.SchoolId, 3)}
                disabled={impersonateLoading[`insights-${Product.PARENTS_INSIGHTS}-${schoolProds.SchoolId}`]}
              >
                {impersonateLoading[`insights-${Product.PARENTS_INSIGHTS}-${schoolProds.SchoolId}`] ? 'Loading...' : 'Parents Insights'}
              </ProdButton>
            )}
            {schoolProds.Product === Product.STAFF_INSIGHTS && (
              <ProdButton                
                className='student-chip'
                onClick={() => handleSchoolInsightsclick(schoolProds.MatId, schoolProds.SchoolId, 4)}
                disabled={impersonateLoading[`insights-${Product.STAFF_INSIGHTS}-${schoolProds.SchoolId}`]}
              >
                {impersonateLoading[`insights-${Product.STAFF_INSIGHTS}-${schoolProds.SchoolId}`] ? 'Loading...' : 'Staff Insights'}
              </ProdButton>
            )}
            {EI_TIER_PRODUCT_IDS.includes(schoolProds.Product) && (
              <ProdButton                
                className='edu-chip'
                onClick={() => handleEDUIntellSchoolclick(schoolProds.MatId, schoolProds.SchoolId)}
                disabled={impersonateLoading[`edu-${schoolProds.SchoolId}`]}
              >
                {impersonateLoading[`edu-${schoolProds.SchoolId}`] ? 'Loading...' : PRODUCT_DISPLAY_NAMES[schoolProds.Product]}
              </ProdButton>
            )}
            {schoolProds.Product === Product.PULSE && (
              <ProdButton label='Pulse' className='lparent-chip'>Pulse</ProdButton>
            )}
          </React.Fragment>
        ))}
      </ProductCell>
    );
  };

  // Row actions: Home (impersonate), Detail (navigate) and, for Super Admins, Archive.
  const renderActions = (row) => (
    <ActionCell>
      <HomeButton        
        onClick={() => handleSchoolHomeclick(row.MatGroupId ?? 0, row.Id)}
        disabled={impersonateLoading[`home-${row.Id}`]}
      >
        {impersonateLoading[`home-${row.Id}`] ? 'Loading...' : 'Home'}
      </HomeButton>
      <PillButton type='button' onClick={() => handleSchoolDetails(row.Id)}>
        Detail
      </PillButton>
      {canArchive && (
        <PillButton type='button' $variant='danger' onClick={() => handleArchiveClick(row.Id)}>
          Archive
        </PillButton>
      )}
    </ActionCell>
  );

  const schoolColumns = [
    {
      key: 'Name',
      header: sortHeader('School Name', 'Name'),
      width: '22%',
      render: (row) => <SchoolNameText>{row.Name}</SchoolNameText>,
    },
    {
      key: 'WondeeSchoolUrn',
      header: sortHeader('School URN', 'WondeeSchoolUrn'),
      width: '12%',
      render: (row) => row.WondeeSchoolUrn,
    },
    {
      key: 'Email',
      header: sortHeader('Account Holder', 'Email'),
      width: '18%',
      render: (row) => row.Email,
    },
    {
      key: 'Products',
      header: sortHeader('Products', 'Products'),
      cellStyle: wrapCellStyle,
      render: renderProductButtons,
    },
    {
      key: 'action',
      label: 'Action',
      width: '240px',
      cellStyle: wrapCellStyle,
      render: renderActions,
    },
  ];

  return (
    <AppContainer>
      <SideMenu />
      <BodyContainer>
        <Header />
        <MainContentContainer>
          <PageStack>
            <SectionHeaderRow title='Schools' size='lg'>
              <SearchForm onSubmit={(e) => e.preventDefault()}>
                <SearchIcon />
                <input
                  placeholder='Enter keyword'
                  aria-label='search schools'
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </SearchForm>
              <PillButton
                type='button'
                $variant='danger'
                $size='lg'
                onClick={() => navigate.push(routesObj.RegisterSchool.path)}
              >
                Add School
              </PillButton>
            </SectionHeaderRow>

            <TabBar>
              <TabButton type='button' $active={value === 0} onClick={(e) => handleTabChange(e, 0)}>
                Live Schools
              </TabButton>
              <TabButton type='button' $active={value === 1} onClick={(e) => handleTabChange(e, 1)}>
                Test Schools
              </TabButton>
            </TabBar>

            {loading === true ? (
              <CenterState>
                <CircularProgress />
              </CenterState>
            ) : (
              <div>
                <DataTable
                  columns={schoolColumns}
                  rows={sortedWelbeeData}
                  getRowKey={(row) => row.Id}                  
                  empty='No schools found.'
                />
                <PaginationRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 20, 30, 50]}
                    component='div'
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleWelbeeChangePage}
                    onRowsPerPageChange={handleWelbeeChangeRowsPerPage}
                  />
                </PaginationRow>
              </div>
            )}
          </PageStack>

          {/* Add School Modal */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Add School
              </Typography>
              <Grid container spacing={1.5} mt={1}>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                      <FormControl fullWidth>
                          <TextField
                              name='establishmentName'
                              id='school-name'
                              label='School Name'
                              value={formData.establishmentName}
                              onChange={handleInputChange}
                          />
                      </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                      <FormControl fullWidth>
                          <TextField
                              name='address3'
                              id='address3'
                              label='Address'
                              value={formData.address3}
                              onChange={handleInputChange}
                          />
                      </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                      <FormControl fullWidth>
                          <TextField
                              name='urn'
                              id='urn'
                              label='Unique Reference Number (URN)'
                              value={formData.urn}
                              onChange={handleInputChange}
                          />
                      </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                      <FormControl fullWidth>
                          <TextField
                              name='numberofpupils'
                              id='number-of-pupils'
                              label='Number of Pupils'
                              value={formData.numberofpupils}
                              onChange={handleInputChange}
                          />
                      </FormControl>
                  </Grid>
                  <Grid item xs={12} lg={12} md={12} sm={12}>
                      <FormControl fullWidth>
                      <InputLabel id="multi-select-label2">Select Products</InputLabel>
                          <Select
                          id="add-prodcuts"
                          multiple
                          labelId='multi-select-label2'
                          value={productName}
                          label="Products"
                          onChange={handleProductChange}
                          input={<OutlinedInput id="select-multiple-chip" />}
                          renderValue={(selected) => (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((value) => (
                                  <Chip key={value} className='schoolname-chip' label={value} onDelete={handleChipDelete}/>
                              ))}
                              </Box>
                          )}
                          //MenuProps={MenuProps}
                          >
                          {PRODUCT_NAMES.map((item) => (
                              <MenuItem
                              key={item.id}
                              value={item.name}
                              >
                              {item.name}
                              </MenuItem>
                          ))}
                          </Select>
                      </FormControl>
                  </Grid>
                   <Grid item xs={12} lg={12} md={12} sm={12}>
                    <FormControl fullWidth>
                        <OutlinedInput
                            type='file'
                            name='file-7[]'
                            id='file-7'
                            accept='image/x-png,image/jpeg'
                            className='inputfile inputfile-6'
                            data-multiple-caption='{count} files selected'
                            endAdornment={
                                <InputAdornment position="end">
                                    <AppButton color={mandy}  className='search-btn'>Upload</AppButton>
                                </InputAdornment>
                                }
                            onChange={(event) => {
                            var files = event.target.files;
                            var file = files[0];
                            var splitFileName = file.name.split('.');
                            var imageName = splitFileName[0];
                            var trancateString =
                                imageName.length > 23
                                ? imageName.substr(imageName, 23, 0) + '...'
                                : file.name;
                            if (files && file) {
                                var reader = new FileReader();
                                reader.onload = function (readerEvt) {
                                var binaryString = readerEvt.target.result;
                                setFile(btoa(binaryString));
                                setFileName(file.name);
                                setTrancateFileName(trancateString);
                                };
                                reader.readAsBinaryString(file);
                            }
                            }}
                        />
                    </FormControl>
                </Grid>
               <Grid item xs={12} lg={12} md={12} sm={12} textAlign='right' mt={1}>
                {addloading===true? (
                  <div className="center-section-loader">
                  <CircularProgress />
                  </div>
                  ) : (<AppButton color={mandy} type='submit' onClick={addItem} >Add School</AppButton>)}
              </Grid>
              </Grid>
            </Box>
          </Modal>
          <ConfirmDialog {...archiveDialogProps} />
        </MainContentContainer>
      </BodyContainer>
    </AppContainer>


  );
}

export default withRouter(SchoolListing);
